export const api = {
  user: {
    requestEmailChanges: (apiUrl: string): string =>
      `${apiUrl}/verification/email`,
    getProfile: (apiUrl: string, accessToken: string): string =>
      `${apiUrl}/users/${accessToken}`,
    me: (apiUrl: string): string => `${apiUrl}/users/me`,
  },
  userSettings: {
    crud: (apiUrl: string): string => `${apiUrl}/user-settings`,
    me: (apiUrl: string): string => `${apiUrl}/user-settings/me`,
    setLanguage: (apiUrl: string): string =>
      `${apiUrl}/user-settings/set-language`,
    setTheme: (apiUrl: string): string => `${apiUrl}/user-settings/set-theme`,
    setWeeklySubscription: (apiUrl: string): string =>
      `${apiUrl}/user-settings/set-weekly-subscription`,
    setDevicePageView: (apiUrl: string): string =>
      `${apiUrl}/user-settings/set-device-page-view`,
    setGlobalSearchSettings: (apiUrl: string): string =>
      `${apiUrl}/user-settings/set-global-search-settings`,
    verification: (apiUrl: string): string => `${apiUrl}/verification`,
    verificationOne: (apiUrl: string, verificationId: string): string =>
      `${apiUrl}/verification/${verificationId}`,
    g2Review: (apiUrl: string): string => `${apiUrl}/g2/review`,
    g2ReviewRemindLater: (apiUrl: string): string =>
      `${apiUrl}/g2/review/remind-later`,
    g2ReviewDontAskAgain: (apiUrl: string): string =>
      `${apiUrl}/g2/review/dont-ask-again`,
    g2ReviewFeedback: (apiUrl: string): string =>
      `${apiUrl}/g2/review/feedback`,
  },
};
